import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useResultsPanelContext } from "@/components/Search/SearchBar/components/ResultsPanel/context/resultsPanel.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Panel = ({ className, children }: Props) => {
    const { onMouseDown, onKeyDown } = useResultsPanelContext();

    return (
        <div
            className={cn(className)}
            onMouseDown={onMouseDown}
            onKeyDown={onKeyDown}
        >
            {children}
        </div>
    );
};
